const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validEmail = (email: string) => {
  return emailRegex.test(email);
};
